import Swal from "sweetalert2";
import axios from "../../axios";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";
import {
  GET_ALL_WALLET,
  ADD_WALLET,
  UPDATE_WALLET,
  UPDATE_STATUS_WALLET,
  DELETE_WALLET,
  GET_BALANCE,
} from "../types";

// ===============================
// 👉 ADD WALLET
// ===============================
export const addWallet = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("wallet/add", formData);
    if (res.data.code === 1) {
      dispatch({ type: ADD_WALLET, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
      if (res.data.code === 0) {
        console.log("here :", res.data.message);
        Swal.fire({
          title: "Warning!",
          text: res.data.message,
          icon: "warning",
        });
      }
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    const errorMessage = getErrorMessage(err.response?.data);
    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};

// ===============================
// 👉 GET ALL WALLETS
// ===============================
export const getWallet = () => async (dispatch) => {
  try {
    const res = await axios.get("wallet/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_ALL_WALLET, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 UPDATE WALLET
// ===============================
export const updateWallet = (formData) => async (dispatch) => {
  try {
    const res = await axios.post("wallet/update", formData);
    if (res.data.code === 1) {
      dispatch({
        type: UPDATE_WALLET,
        payload: res.data.data,
      });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 UPDATE WALLET STATUS
// ===============================
export const updateWalletStatus = (formData) => async (dispatch) => {
  try {
    const updatedFormData = {
      id: formData.id,
      ...(formData.status !== undefined && { status: formData.status }),
    };

    const res = await axios.post("wallet/update/status", updatedFormData);
    if (res.data.code === 1) {
      dispatch({
        type: UPDATE_STATUS_WALLET,
        payload: res.data.data,
      });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 DELETE WALLET
// ===============================
export const deleteWallet = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`wallet/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_WALLET, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};

// ===============================
// 👉 GET BALANCE
// ===============================
export const getBalance = (cudId) => async (dispatch) => {
  try {
    const res = await axios.get(`wallet/bal/${cudId}`);
    if (res.data.code === 1) {
      dispatch({ type: GET_BALANCE, payload: res.data.data });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
  }
};
